import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../hooks/useLanguage';
import { Category } from '../../types/api';

interface CategoryCardProps {
  category: Category;
}

export function CategoryCard({ category }: CategoryCardProps) {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const categoryName = currentLanguage === 'ar' ? category.name : category.nameEn;
  const categoryDescription = currentLanguage === 'ar' 
    ? category.description 
    : category.descriptionEn;

  return (
    <Link
      to={`/catalog/category/${category._id}`}
      className="block bg-neutral-dark/50 backdrop-blur-sm border border-neutral-dark rounded-lg p-6 hover:border-brand-accent/50 hover:shadow-lg hover:shadow-brand-accent/20 transform hover:scale-105 transition-all duration-300 group"
    >
      <div className="flex flex-col h-full">
        {/* Category Name */}
        <h3 className="text-xl font-heading font-bold text-brand-accent mb-2 group-hover:text-brand-accent/80 transition-colors">
          {categoryName}
        </h3>

        {/* Description */}
        {categoryDescription && (
          <p className="text-sm text-neutral-medium font-body mb-4 flex-1">
            {categoryDescription}
          </p>
        )}

        {/* Footer Info - نعرض السعر والكمية فقط إذا لم تكن الفئة أب (isParent === false) */}
        {!category.isParent && (
          <div className="flex items-center justify-between pt-4 border-t border-neutral-dark">
            <div className="flex flex-col">
              <span className="text-xs text-neutral-medium font-body">
                {t('catalog.category.price')}
              </span>
              <span className="text-lg font-heading font-bold text-brand-accent">
                {category.price.toFixed(2)} USD
              </span>
            </div>

            <div className="flex flex-col items-end">
              <span className="text-xs text-neutral-medium font-body">
                {t('catalog.category.available')}
              </span>
              <span className="text-lg font-heading font-bold text-neutral-light">
                {category.availableProductsCount}
              </span>
            </div>
          </div>
        )}

        {/* Cashback Badge - نعرض الكاش باك فقط إذا لم تكن الفئة أب */}
        {!category.isParent && category.isEnabledCashback && (
          <div className="mt-3 inline-flex items-center gap-1 px-2 py-1 bg-brand-accent/20 text-brand-accent rounded-full text-xs font-body">
            <span>💰</span>
            <span>
              {t('catalog.category.cashback')} {(category.cashbackPercentage * 100).toFixed(0)}%
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}

